/// <reference path="./AbstractNode.class.ts" />

namespace ui
{
	export namespace tree
	{
		export class TreeView
			extends AbstractNode
		{
			public constructor( root: JQuery|ui.base.BaseHTMLElement )
			{
				super( 'ul', root );
			}

			public rebuild() {}
		}
	}
}
